module.exports = __webpack_public_path__ + "static/media/image_63.95f51c8e.png";